<template>
  <TopLine :style="styleTopline" :title="topLineTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>
  <ion-list id="multiple-option" :style="styleMiddle">
    <ion-item v-for="item in displayArray"  @click="onClick(item.index)" v-bind:key="item.index"
                  :class="{ 
                  'text-light' : isDark,
                  'text-dark' : !isDark }">
      <ion-label >
        <h1 class="myheading" >{{ item.heading }}</h1>
        <p class="mylabel">{{ item.currentString }}</p>
      </ion-label>
    </ion-item>
  </ion-list>
  <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
</template>

<script setup>

  import { IonPage, IonContent,IonList,IonItem,IonLabel  } from '@ionic/vue';
  import TopLine from '@/components/TopLine.vue'

  import { computed } from "@vue/reactivity"
  import { ref , watch } from 'vue'

  import ToolBar from '@/components/ToolBar.vue'
  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, scrollElement,
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { translateEnglishWords, translatePhrase } from '@/composables/translation';
  import { parseWordsSaid , parseGeneralWordsSaid } from '@/composables/wordlistSupport.js'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  const topLineTitle = ref(translateEnglishWords("Options"))
  const connectionStore = useConnectionStore()

  const windowSizeStore = useWindowSizeStore()


  const isDark = ref(connectionStore.getDarkmode != "light")

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)

  const emit = defineEmits(['item-selected','toolbar-click'])

  var scrollTop = 0
  //Vue.$honeybadger.notify('Hello from Vue in multi')

  const props = defineProps({
    displayArray : Array,
    wordsSpoken : String,
    wordsSpokenTrigger : Number
  })

  var displayWordsArray = []
  for (var i=0; i < props.displayArray.length; i++)
    displayWordsArray.push(props.displayArray[i].headingWords)

  const displayArray = computed({ get() { return props.displayArray }})
  const wordsSpoken = computed({ get() { return props.wordsSpoken } })
  const wordsSpokenTrigger = computed({ get() { return props.wordsSpokenTrigger } })

    //console.log("************* Multipe aarray ",props.displayArray)

  watch(() => windowSizeStore.getWindowSize, () => {
      styleToolbar.value = buildStyleToolbar(availableWidthHeight())
      styleTopline.value = buildStyleTopline(availableWidthHeight())
      styleMiddle.value = buildStyleMiddle(availableWidthHeight())
    })

  watch(wordsSpokenTrigger, (newVal,oldVal) => {
    //console.log('*********** words spoken changed',props.wordsSpoken)
    processWords(props.wordsSpoken)

  })

  const TOOLBAR_EXPLAIN = 0

  const toolbarElements = [
    { index : TOOLBAR_EXPLAIN, label : translateEnglishWords("Explain") ,disabled : false}
  ]

  const toolbarTrigger = ref(0)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  //console.log("Middle ",styleMiddle.value)

  function toplineClick(whatClicked) {
    //console.log("topline in multi-options",whatClicked)
    switch (whatClicked) {
      case "done" :
        //processWords("command done")
        emit("toolbar-click","done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        emit("toolbar-click",microphoneIsMuted.value ? "mute" : "listen")
        break
    }
  }

  function onClick(index) {
    //console.log("option index ",index)
    emit('item-selected',index)
  }

  function toolbarClick(arrayIndex) {
    //console.log("toolbar click and show state ",arrayIndex)
    switch (arrayIndex) {
      case TOOLBAR_EXPLAIN :
        emit("toolbar-click","explain")
        break
    }
  }

  function processWords(text) {
    const command = parseGeneralWordsSaid(text,displayWordsArray)
    //console.log("****** command for multiple options",command,command[0])
  
    switch (command[0]) {
      case "mute" :
        if (microphoneIsMuted.value == true)
          break
        microphoneIsMuted.value = true 
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        emit("toolbar-click","mute")
        break
      case "listen" :
        if (microphoneIsMuted.value == false)
          break
        microphoneIsMuted.value = false 
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        emit("toolbar-click","listen")
        break
      case "choice" :
        emit('item-selected',command[1])
        break      
      case "done" :
        //console.log("***** DONE WITH MULTIPLE CHOICE *****************")
        emit("toolbar-click","done")
        break
      case "explain" :
        emit("toolbar-click","explain")
        break
      case "scroll" :
        scrollElement("multiple-option",command[1])
        break
    }
  }

 
</script>

<style scoped>

.mylabel {
  font-size : 18px;
}

.myheading {
  background: #4c6ca0;
  color : white;
  font-size : 20px;
}


</style>